import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiUrl, toFormData } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class BuyticketsService {

constructor( private http: HttpClient,) { }

getMatchticket(request?:any) {
  return this.http.post(apiUrl('beforeauth/getmatchticketlist'),toFormData(request)).toPromise().then((data:any)=>{
   
      return data;
   
  })
}

getSinglematchticket(request?:any) {
  return this.http.post(apiUrl('beforeauth/getmatchticketdetail'),toFormData({Matchticket: request})).toPromise().then((data:any)=>{
   
      return data;
   
  })
}

}
